import { Module } from "wrapper6";
import Swiper from 'swiper/bundle';

var $ = jQuery;

export default class OccasionSliders extends Module {
    ready(app) {
        const OCCASION_SLIDERS = document.querySelectorAll('.mtt-occasion-widget');
        if (OCCASION_SLIDERS.length > 0) {
            for (let i = 0; i < OCCASION_SLIDERS.length; i++) {
                new OccasionSlider(OCCASION_SLIDERS[i]);
            }
        }
    }
}

class OccasionSlider {

    constructor(WRAPPER) {

        const SWIPER_CONTAINER = WRAPPER.querySelector('.swiper-container');
        const PREV = WRAPPER.querySelector('.swiper-button-prev');
        const NEXT = WRAPPER.querySelector('.swiper-button-next');

        const SWIPER = new Swiper(SWIPER_CONTAINER, {
            slidesPerView: 1.2,
            speed: 800,
            spaceBetween: 24,
            freeMode: false,
            watchOverflow: true,
            navigation: {
                nextEl: NEXT,
                prevEl: PREV,
            },
            breakpoints: {
                451: {
                    spaceBetween: 24,
                    slidesPerView: 1.6
                },
                651: {
                    spaceBetween: 24,
                    slidesPerView: 2.4
                },
                851: {
                    spaceBetween: 24,
                    slidesPerView: 3
                },
                961: {
                    spaceBetween: 40,
                    slidesPerView: 3
                },
                1281: {
                    spaceBetween: 40,
                    slidesPerView: 4
                }
            }
        });
    }
}